import { Helmet } from "react-helmet-async";
import siteConfig from "../../data/siteConfig.json";

const defaultSiteUrl = "https://www.nexteraabroad.com";

function normalizePath(path = "/") {
  if (!path || path === "/") return "/";
  return path.startsWith("/") ? path : `/${path}`;
}

function buildAbsoluteUrl(path = "/") {
  const baseUrl = process.env.REACT_APP_SITE_URL || defaultSiteUrl;
  const cleanBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  const cleanPath = normalizePath(path);
  return `${cleanBase}${cleanPath}`;
}

function SeoHead({
  title,
  description,
  path = "/",
  keywords = [],
  image = siteConfig.images.hero,
  type = "website"
}) {
  const canonical = buildAbsoluteUrl(path);
  const keywordContent = keywords.length ? keywords.join(", ") : undefined;
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: siteConfig.brand.name,
    url: buildAbsoluteUrl("/"),
    description: siteConfig.brand.summary,
    telephone: siteConfig.contact.phone,
    email: siteConfig.contact.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: siteConfig.contact.address
    },
    sameAs: [siteConfig.social.instagram, siteConfig.social.linkedin, siteConfig.social.facebook]
  };

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywordContent ? <meta name="keywords" content={keywordContent} /> : null}
      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteConfig.brand.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    </Helmet>
  );
}

export default SeoHead;
